<template>
<div>
    
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                   <div class="row breadcrumbs-top">
                      <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" style="border: none!important;"> Dashboard </h3>
                            <div class="breadcrumb-wrapper">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><router-link to='/mydashboard'>Home</router-link>
                                        </li>
                                        
                                        <li class="breadcrumb-item active">My Dashboard
                                        </li>
                                    </ol>
                                </div>
                      </div>
                   </div>
                </div>
                
            </div>
            <div class="content-body">
                <vue-element-loading :active="isLoading"  :is-full-screen="true"/>
                <div class="card p-1 pb-0 dashboard_main_view_dock">
                    <div class="my_dashboard_main_page jumbotron_bg dashboard_secondview px-1 pt-1 pb-0">
                       
                                <div class="container">
                                    <div class="row">
                                        <div class="col-12 col-sm-12 col-md-10 col-lg-10 first_order-sm-1"> 
                                             <div class="dashboardMaincontent">
                                                <div class="dashboardMaincontent_text">
                                                    <h3 class=""> Optimize Your Logistics with Our 
                                                        Advanced Dock Management System
                                                </h3>
                                               
                                                </div>
                                             </div>
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-2  col-lg-2 second_order-sm-0"> 
                                            <div class="dashboardMainLogo p-1 pt-2">
                                                <img alt=""  class="round" src="../../public/images/logo/gatilogo.png">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body pt-1 px-0 mb-30">
                                    <div class="row">
                                        <div class="col-6 col-sm-6 col-md-4 col-lg-4 mb-1 pr-0">
                                            <label class="input_label">From Date</label>
                                            <date-picker placeholder="From Date" v-model="search.start_date" valueType="format" class="startdate w-100 dashboard_date_box" ></date-picker>
                                        </div>
                                        <div class="col-6 col-sm-6 col-md-4 col-lg-4 mb-1">
                                            <label class="input_label">To Date</label>
                                            <date-picker placeholder="To Date" v-model="search.end_date" valueType="format" class="startdate w-100 dashboard_date_box" ></date-picker>
                                        </div>

                                        <!-- <div class=" text-left mb-1 home_das_all_buttons_style row"> -->
                                            <div class="col-6 col-sm-6 col-md-4 col-lg-1 pr-0 pl_ds_0">
                                                <label class="dis_none_ms">&nbsp;</label>
                                                <button type="submit" class="w-100 waves-effect serach_btn" @click="getDashboardDataCounts()">
                                                    Search
                                                </button>
                                            </div>
                                            <div class="col-6 col-sm-6 col-md-4 col-lg-1">
                                                <label class="dis_none_ms">&nbsp;</label>
                                                <button type="submit" class="w-100 waves-effect clear_btn" @click="resetFilters">
                                                    clear
                                                </button>
                                            </div>
                                        <!-- </div> -->
                                    </div>
                                </div>
                                <div class="row match-height customAnimation card_crossdock_main dashboard_main_container">
                                <div class="col-6 col-sm-4 col-md-4 col-lg-2 card_crossdock_main_padding mb-1">
                                    <div class="card text-center my_projects-bgs_co my_projects-bgs-01" >
                                        <div class="card-body card_crossdock_p5 dashboard_icon_bg">
                                        <div class="avatar bg-light-info p-50 mb-1">
                                            <div class="avatar-content avatar_iconsview">
                                                <em class="las la-archway custom-class  font-medium-3"></em>
                                                
                                            </div>
                                        </div>
                                        <h2 class="font-weight-bolder">{{dataPoints.today_gate_entry}}</h2>
                                        <p class="card-text mx-0">Gate Entry</p>
                                    </div>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4 col-md-4 col-lg-2 card_crossdock_main_padding mb-1">
                                    <div class="card text-center my_projects-bgs_co my_projects-bgs-02" >
                                        <div class="card-body card_crossdock_p5 dashboard_icon_bg">
                                        <div class="avatar bg-light-info p-50 mb-1">
                                            <div class="avatar-content avatar_iconsview">
                                                <em class="las la-archway custom-class  font-medium-3"></em>
                                                
                                            </div>
                                        </div>
                                        <h2 class="font-weight-bolder">{{dataPoints.gate_exit}}</h2>
                                        <p class="card-text mx-0">Gate Exit</p>
                                    </div>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4 col-md-4 col-lg-2 card_crossdock_main_padding mb-1">
                                    <div class="card text-center my_projects-bgs_co my_projects-bgs-03">
                                        <div class="card-body card_crossdock_p5 dashboard_icon_bg">
                                        <div class="avatar bg-light-primary p-50 mb-1">
                                            <div class="avatar-content avatar_iconsview">
                                                <em class="las la-sitemap custom-class  font-medium-3"></em>
                                                
                                            </div>
                                        </div>
                                        <h2 class="font-weight-bolder">{{dataPoints.today_dock_allocation}}</h2>
                                        <p class="card-text mx-0"> Dock Allocation</p>
                                    </div>
                                </div>
                                </div>
                                <div class="col-6 col-sm-4 col-md-4 col-lg-2 card_crossdock_main_padding mb-1">
                                    <div class="card text-center my_projects-bgs_co my_projects-bgs-04">
                                        <div class="card-body card_crossdock_p5 dashboard_icon_bg">
                                        <div class="avatar bg-light-primary p-50 mb-1">
                                            <div class="avatar-content avatar_iconsview">
                                                <em class="las la-sitemap custom-class  font-medium-3"></em>
                                                
                                            </div>
                                        </div>
                                        <h2 class="font-weight-bolder">{{dataPoints.dock_entry}}</h2>
                                        <p class="card-text mx-0"> Dock Entry</p>
                                    </div>
                                </div>
                                </div>
                                <div class="col-6 col-sm-4 col-md-4 col-lg-2 card_crossdock_main_padding mb-1">
                                <div class="card text-center my_projects-bgs_co my_projects-bgs-05">
                                    <div class="card-body card_crossdock_p5 dashboard_icon_bg">
                                    <div class="avatar bg-light-secondary p-50 mb-1">
                                        <div class="avatar-content avatar_iconsview">
                                            <em class="las la-store custom-class  font-medium-3"></em>
                                        </div>
                                    </div>
                                    <h2 class="font-weight-bolder">{{dataPoints.available_docks}}</h2>
                                    <p class="card-text mx-0">Available Docks</p>
                                    </div>
                                </div>
                                </div>
                                <div class="col-6 col-sm-4 col-md-4 col-lg-2 card_crossdock_main_padding mb-1">
                                    <div class="card text-center my_projects-bgs_co my_projects-bgs-09">
                                        <div class="card-body card_crossdock_p5 dashboard_icon_bg">
                                        <div class="avatar bg-light-primary p-50 mb-1">
                                            <div class="avatar-content avatar_iconsview">
                                                    <em class="las la-pallet custom-class  font-medium-3"></em>
                                                </div>
                                        </div>
                                        <h2 class="font-weight-bolder">{{dataPoints.occupied_docks}}</h2>
                                        <p class="card-text mx-0">Occupied Docks</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-6 col-sm-4 col-md-4 col-lg-2 card_crossdock_main_padding mb-1">
                                    <div class="card text-center my_projects-bgs_co my_projects-bgs-07">
                                        <div class="card-body card_crossdock_p5 dashboard_icon_bg">
                                        <div class="avatar bg-light-success p-50 mb-1">
                                            <div class="avatar-content avatar_iconsview">
                                                    
                                                    <em class="las la-stamp custom-class  font-medium-3"></em>
                                                </div>
                                        </div>
                                        <h2 class="font-weight-bolder">{{dataPoints.without_seal_count ? dataPoints.without_seal_count : 0}}</h2>
                                        <p class="card-text mx-0">Without seal</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4 col-md-4 col-lg-2 card_crossdock_main_padding mb-1">
                                    <div class="card text-center my_projects-bgs_co my_projects-bgs-08">
                                        <div class="card-body card_crossdock_p5 dashboard_icon_bg">
                                        <div class="avatar bg-light-primary p-50 mb-1">
                                            <div class="avatar-content avatar_iconsview">
                                                    <em class="las la-circle custom-class  font-medium-3"></em>
                                                </div>
                                        </div>
                                        <h2 class="font-weight-bolder">{{dataPoints.seal_count ? dataPoints.seal_count : 0}}</h2>
                                        <p class="card-text mx-0">Seal Count</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4 col-md-4 col-lg-2 card_crossdock_main_padding mb-1">
                                    <div class="card text-center my_projects-bgs_co my_projects-bgs-10">
                                        <div class="card-body card_crossdock_p5 dashboard_icon_bg">
                                        <div class="avatar bg-light-warning p-50 mb-1">
                                            <div class="avatar-content avatar_iconsview">
                                                    
                                                    <em class="las la-bus-alt custom-class  font-medium-3"></em>
                                                </div>
                                        </div>
                                        <h2 class="font-weight-bolder">{{dataPoints.dock_exit}}</h2>
                                        <p class="card-text mx-0">Dock Exit</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4 col-md-4 col-lg-2 card_crossdock_main_padding mb-1">
                                    <div class="card text-center my_projects-bgs_co my_projects-bgs-01">
                                        <div class="card-body card_crossdock_p5 dashboard_icon_bg">
                                        <div class="avatar bg-light-success p-50 mb-1">
                                            <div class="avatar-content avatar_iconsview">
                                                    <em class="las la-pallet custom-class  font-medium-3"></em>
                                                </div>
                                        </div>
                                        <h2 class="font-weight-bolder">{{dataPoints.vehicle_parked}}</h2>
                                        <p class="card-text mx-0">Vehicles Parked</p>
                                        </div>
                                    </div>
                                </div>
                               
                                

                            </div> 
                    </div>
                    <div class="welcome_page_number_container jumbotron_bg dashboard_secondview px-1 pt-1 pb-0">
                        <section id="dashboard-ecommerce" >
                            <div class="row dashTiles card_crossdock_main ">
                                <div class="col-6 col-sm-4  col-md-4 col-lg-2 card_crossdock_main_pd-8">
                                    <div class="card mb-1 text-center my_projects-bgs_co dock_projects-bgs-01" >
                                        <div class="card-body card_crossdock_secondbg">
                                        <div class="crossdock_bg_icon w-100 text-right">
                                        <div class="mb-1">
                                            <div class="avatar_iconsview">
                                                <!-- <em class="las la-warehouse custom-class font-medium-3"></em> -->
                                                <img alt=""  class="" src="../../public/images/logo/warehouse_img.svg">
                                            </div>
                                        </div>
                                        </div>
                                        <h2 class="font-weight-bolder text-left">{{dataPoints.total_warehouses}}</h2>
                                        <p class="card-text mx-0 text-left">Warehouse</p>
                                    </div>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4  col-md-4 col-lg-2 card_crossdock_main_pd-8">
                                    <div class="card mb-1 text-center my_projects-bgs_co dock_projects-bgs-02" >
                                        <div class="card-body card_crossdock_secondbg">
                                            <div class="crossdock_bg_icon w-100 text-right">
                                                <div class="mb-1">
                                                    <div class="avatar_iconsview">
                                                        <!-- <em class="las la-shipping-fast custom-class  font-medium-3"></em> -->
                                                        <img alt=""  class="" src="../../public/images/logo/vehicle_img.svg">
                                                    </div>
                                                </div>
                                            </div>
                                        <h2 class="font-weight-bolder text-left">{{dataPoints.total_vehicles}}</h2>
                                        <p class="card-text mx-0 text-left">Vehicles </p>
                                    </div>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4  col-md-4 col-lg-2 card_crossdock_main_pd-8">
                                    <div class="card mb-1 text-center my_projects-bgs_co dock_projects-bgs-03" >
                                        <div class="card-body card_crossdock_secondbg">
                                      <div class="crossdock_bg_icon w-100 text-right">
                                        <div class="mb-1">
                                            <div class="avatar_iconsview">
                                                <!-- <em class="las la-users-cog custom-class  font-medium-3"></em> -->
                                                <img alt=""  class="" src="../../public/images/logo/vendors_img.svg">
                                            </div>
                                        </div>
                                        </div>
                                        <h2 class="font-weight-bolder text-left">{{dataPoints.total_vendors}}</h2>
                                        <p class="card-text mx-0 text-left">Vendors </p>
                                    </div>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4  col-md-4 col-lg-2 card_crossdock_main_pd-8">
                                    <div class="card mb-1 text-center my_projects-bgs_co dock_projects-bgs-04" >
                                        <div class="card-body card_crossdock_secondbg">
                                    <div class="crossdock_bg_icon w-100 text-right">
                                        <div class="mb-1">
                                            <div class="avatar_iconsview">
                                                <!-- <em class="las la-torii-gate custom-class  font-medium-3"></em> -->
                                                <img alt=""  class="" src="../../public/images/logo/gate_img.svg">

                                            </div>
                                        </div>
                                        </div>
                                        <h2 class="font-weight-bolder text-left">{{dataPoints.total_gates}}</h2>
                                        <p class="card-text mx-0 text-left">Gate </p>
                                    </div>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4  col-md-4 col-lg-2 card_crossdock_main_pd-8">
                                    <div class="card mb-1 text-center my_projects-bgs_co dock_projects-bgs-05" >
                                        <div class="card-body card_crossdock_secondbg">
                                      <div class="crossdock_bg_icon w-100 text-right">
                                        <div class="mb-1">
                                            <div class="avatar_iconsview">
                                                <!-- <em class="las la-anchor custom-class  font-medium-3"></em> -->
                                                <img alt=""  class="" src="../../public/images/logo/docks_img.svg">
                                            </div>
                                        </div>
                                        </div>
                                        <h2 class="font-weight-bolder text-left">{{dataPoints.total_docks}}</h2>
                                        <p class="card-text mx-0 text-left">Docks </p>
                                    </div>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4  col-md-4 col-lg-2 card_crossdock_main_pd-8">
                                    <div class="card mb-1 text-center my_projects-bgs_co dock_projects-bgs-06" >
                                        <div class="card-body card_crossdock_secondbg">
                                        <div class="crossdock_bg_icon w-100 text-right">
                                            <div class="mb-1">
                                                <div class="avatar_iconsview">
                                                    <!-- <em class="las la-map-marked-alt custom-class  font-medium-3"></em> -->
                                                    <img alt=""  class="" src="../../public/images/logo/zones_img.svg">
                                                </div>
                                            </div>
                                        </div>
                                        <h2 class="font-weight-bolder text-left">{{dataPoints.total_zones}}</h2>
                                        <p class="card-text mx-0 text-left">Zones </p>
                                    </div>
                                    </div>
                                </div>
                                <!--  -->
                              
                            </div>
                        </section>
                    </div>
                </div>
           
            </div>
        </div>
    </div>
</div>
</template>

<script>

import VueElementLoading from 'vue-element-loading'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'
import common_methods from "../utils/common_methods"
import searchMasterNameList from "../utils/searchMasterNameList"

export default({
    name:'Welcome',
    data() {
        return {
            isLoading: false,
            search: {
                end_date: null,
                start_date: null
            },
            dataPoints: {
                today_gate_entry: 0,
                gate_exit: 0,
                today_dock_allocation: 0,
                dock_entry: 0,
                dock_exit: 0,
                vehicle_parked: 0,
                seal_count: 0,
                without_seal_count: 0,
                available_docks: 0,
                occupied_docks: 0,
                total_warehouses: 0,
                total_vehicles: 0,
                total_vendors: 0,
                total_gates: 0,
                total_docks: 0,
                total_zones: 0
            }
        }  
    } ,
    mixins: [ common_methods, searchMasterNameList ],
    components: {
        VueElementLoading,
        DatePicker,
    },
    mounted(){
        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
        if (feather) {
            feather.replace({
                width: 14,
                height: 14
            });
        }
        this.getDashboardDataCounts()
    },
    methods: {
        getDashboardDataCounts() {
            this.isLoading = true
            this.makeRequest("POST", "/stats/dashboard-data-points", this.search)
                .then(result => {
                    this.isLoading = false
                    this.dataPoints = result.data.data
                })
                .catch(e => {
                    this.displayError(e)
                })
        },
        resetFilters() {
            this.search.start_date = null
            this.search.end_date = null
            this.getDashboardDataCounts()
        }
    }
})
</script>
<style scoped>
.alignment{
    margin-left: 20px;
    margin-bottom: 20px;
}
</style>